import { StyledLabel } from "./styled";

const Label = ({ children, ...restProps }) => (
  <StyledLabel {...restProps}>{children}</StyledLabel>
);
export default Label;
